export default {
    path: '',
    component: () => import(`@/component/admin-layout/index.vue`),
    children: [
        {
            path: '/admin/yinzhilv/demo-InternationalTicketAirportSelector',
            name: 'admin-yinzhilv-demo-InternationalTicketAirportSelector',
            component: () => import(`./index.vue`),
            meta: {
                entity_for_history_tag: {
                    name: `demo-InternationalTicketAirportSelector`,
                },
                entity_list_for_breadcrumb: [
                    {name: `demo`},
                    {name: `demo-InternationalTicketAirportSelector`},
                ],
            },
        },
    ],
};
